module.exports = __webpack_public_path__ + "img/lingoAce.04942c71.png";